import React, { createContext, useContext } from 'react';
const UserManagementStatusContext = createContext({
    statusConfig: null,
    isAllOrgContext: false,
    effectiveOrgId: 0,
});
export const UserManagementStatusProvider = ({ statusConfig, isAllOrgContext, effectiveOrgId, children }) => (React.createElement(UserManagementStatusContext.Provider, { value: { statusConfig, isAllOrgContext, effectiveOrgId } }, children));
export const useUserManagementAuthFlags = () => {
    const { statusConfig } = useContext(UserManagementStatusContext);
    return statusConfig?.status?.authentication ?? {};
};
export const useUserManagementOrgContext = () => {
    const { isAllOrgContext, effectiveOrgId } = useContext(UserManagementStatusContext);
    return { isAllOrgContext, effectiveOrgId };
};
//# sourceMappingURL=user-management-status-context.js.map